import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

import { FavoriteDirection } from 'shared/api/avia/favorites/model'

import { isDifficultAviaRoute } from './is-difficult-avia-route'

export const mapSearchDirectionsForRequest = (
  directions?: DifficultRoute[] | [] | null,
): FavoriteDirection[] => {
  const isDifficultRoute = isDifficultAviaRoute(directions)

  if (isDifficultRoute) {
    return (
      directions?.map((item) => ({
        from_: item.from?.cityIataCode,
        to: item.to?.cityIataCode,
        date_: item.date,
      })) ?? []
    )
  }

  const simpleSearch = directions?.[0]

  const result: FavoriteDirection[] = [
    {
      date_: simpleSearch?.date,
      to: simpleSearch?.to?.cityIataCode,
      from_: simpleSearch?.from?.cityIataCode,
    },
  ]

  if (simpleSearch?.back_date) {
    result.push({
      from_: simpleSearch?.to?.cityIataCode,
      to: simpleSearch?.from?.cityIataCode,
      date_: simpleSearch?.back_date,
    })
  }

  return result
}
